
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streamers",
      function () {
        return require("private-next-pages/streamers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/streamers"])
      });
    }
  